module.exports = __webpack_public_path__ + "img/close.90ce25de.svg";